import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c17d639e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lb-stats-item-box" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = {
  key: 0,
  class: "data"
}
const _hoisted_4 = {
  key: 0,
  class: "prefix"
}
const _hoisted_5 = {
  key: 1,
  class: "suffix"
}
const _hoisted_6 = {
  key: 1,
  class: "explain"
}
const _hoisted_7 = {
  key: 0,
  class: "lb-stats-item-icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['lb-stats', `lb-stats-${_ctx.datas.length}`])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.datas, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "lb-stats-item",
        style: _normalizeStyle({
        background: i.color ? i.color : '',
        boxShadow: i.color ? `0 0 4px ${i.color}` : '',
      })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(i.label), 1),
          (i.data)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (i.data.prefix)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(i.data.prefix), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("strong", null, _toDisplayString(i.data.value), 1),
                (i.data.suffix)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(i.data.suffix), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (i.explain)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(i.explain), 1))
            : _createCommentVNode("", true)
        ]),
        (i.icon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("i", {
                class: _normalizeClass(`iconfont icon-${i.icon}`)
              }, null, 2)
            ]))
          : _createCommentVNode("", true)
      ], 4))
    }), 256))
  ], 2))
}